<template>
  <div>
    <div class="profile-card">
      <v-avatar @click="viewProfile" v-if="item.profile_image" class="mr-3"
        ><img :src="item.profile_image"
      /></v-avatar>
      <v-avatar @click="viewProfile" v-else class="mr-3"
        ><img src="/images/default-profile.jpg"
      /></v-avatar>
      <div class="profile-info ml-2">
        <h5 @click="viewProfile" class="name ma-0" v-if="item">
          {{ item.firstname }} {{ item.lastname }}
        </h5>
        <small @click="viewProfile" class="deignation d-block"
          >@{{ item.username }}</small
        >
        <v-chip x-small>{{ item.connects.length }} connects</v-chip>
      </div>
      <div class="d-block d-lg-none ml-auto">
        <request-system :user="item" />
      </div>
    </div>
    <div class="d-none d-lg-block">
      <request-system :user="item" />
    </div>
  </div>
</template>

<script>
import RequestSystem from "./RequestSystem.vue";
export default {
  components: { RequestSystem },
  name: "ProfieUserCard",
  props: ["isConnectBtn", "item"],
  mounted() {},
  methods: {
    viewProfile() {
      console.log(this.item);
      this.getSocialUser(this.item.id);
      this.$router.push(`/profile/${this.item.id}`);
    },
  },
};
</script>

<style scoped>
.profile-card {
  height: 80px;
  display: flex;
  align-items: center;
  line-height: 1.2;
}
</style>